<template>
  <div class="header">
    <img alt="android status bar" src="../assets/android-status-bar.png" />
    <span class="time">{{ time }}</span>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      time: ``
    };
  },
  methods: {
    updateTime() {
      let today = new Date();
      let timeUpdate = today
        .toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit"
        })
        .slice(0, -2);

      if (timeUpdate[0] === "0") {
        this.time = timeUpdate.slice(1);
      } else {
        this.time = timeUpdate;
      }
    }
  },
  mounted() {
    this.updateTime();
    setInterval(this.updateTime, 60000);
  }
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  z-index: 50;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
  }

  .time {
    position: absolute;
    right: 1%;
    top: 0.25%;
    font-size: 1.5vh;
    color: #fafafa;

    @media only screen and (max-width: 600px) {
      top: 0.25%;
      right: 2%;
      font-size: 3.5vw;
    }
  }
}
</style>
